<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    长圳站<br>
站点介绍<br>
长圳站位于光明新区科裕路与光侨路交叉口以北，紧邻车站以商业和居住用地为主，西邻地铁6号线长圳车辆段，东侧为保障性住房项目。 车站结构形式为全框架结构。共4个出入口。车站两端为设备区，中部为公共区。车站总建筑面积约两万二千平方米。站厅层公共区建筑面积约两千三百平米，站台层公共区建筑面积约两万平方米，车站总长约一百五十米。是六号线普通标准站的配置标准。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
科学馆	06:04	23:30	6号线	3分24秒	6分20秒<br>
松岗	06:20	23:41	6号线	3分24秒	6分20秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
科学馆	06:11	23:30	6号线	4分45秒	6分钟<br>
松岗	06:26	23:41	6号线	4分45秒	6分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
科学馆	06:11	00:30	6号线	4分45秒	6分钟<br>
松岗	06:26	00:41	6号线	4分45秒	6分钟<br><br>
<br>
站点出口信息<br>
A出入口:<br>
科裕路东侧(北) 、光侨路北侧（东）、凤凰英荟城<br><br>
B出入口:<br>
凤凰城实验学校、科裕路东侧(南)、凤凰英荟城<br><br>
C出入口:<br>
科裕路西侧(北)<br><br>
D出入口:<br>
长圳车辆段、科裕路西侧(南) 光侨路北侧(西)<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 长圳地铁站<br>
B926路，B947路，B971路，M218路，B959路，M336路，M356路、M451路、高峰专线187号、高峰专线149<br><br>
D出入口:<br>
公交站名： 长圳地铁站<br>
B926路，B971路，M218路，M436路,B959路,M451路，M356路，B947路、M336路、高峰专线187号、高峰专线149<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "liuhaoxian",
          title: "6号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>